/**
 * Key for this feature.
 */
export const FEATURE_KEY = 'features/breakout-rooms';
/**
 * Feature to rename breakout rooms.
 */
export const BREAKOUT_ROOMS_RENAME_FEATURE = 'rename';
